import '@css/common/PrivateCommunityIcon.scss'
import React from 'react'

const PrivateCommunityIcon = () => {
  return <div className="icon-container" />
}

export default PrivateCommunityIcon
